@if (httpError == '404') {
	<mat-error class="top-right-absolute-error-message">
		{{ 'mes.administration.printer.shared.errors.not-found' | translate }}
	</mat-error>
}
@if (httpError == '500') {
	<mat-error class="top-right-absolute-error-message">
		{{ 'mes.administration.printer.shared.errors.internal-server-error' | translate }}
	</mat-error>
}

<h1 mat-dialog-title class="notification-title no-select">
	{{ 'mes.administration.printer.delete.heading' | translate }}
</h1>
<mat-dialog-content>
	<p>{{ 'mes.administration.printer.delete.content' | translate: { name: printer.alias } }}</p>
</mat-dialog-content>
<mat-dialog-actions>
	<button mat-flat-button color="primary" (click)="onDelete()" (window:keyup.enter)="onDelete()" [disabled]="loading">
		{{ 'mes.administration.printer.shared.okbtn' | translate }}
	</button>
	<button mat-flat-button color="primary" (click)="onCancel()" (window:keyup.escape)="onCancel()">
		{{ 'mes.administration.printer.shared.cancelbtn' | translate }}
	</button>
</mat-dialog-actions>
